// Phase 5.4 · 더보기 허브
// 자주 사용하지 않는 통계 · 광고 · 충전금 · 사용내역 · 판매자 프로필 · 설정 · 팔로워
// 및 아직 심플뷰에 배치되지 않은 상세 화면 접근 (RMA · 방송관리 · OMS · 출고관리 · 발주관리 · 입고관리)
import React from 'react';
import { Link } from 'react-router-dom';
import { BarChart3, Megaphone, Wallet, Receipt, User as UserIcon, Settings, Users2, RotateCcw, Radio, ClipboardList, ScanLine, ShoppingCart, PackagePlus, Package, Ticket, Film, MessageCircle } from 'lucide-react';

const GROUPS = [
  {
    title: '판매 프로모션',
    items: [
      { key: 'groupbuy-coupon', label: '공동구매 · 쿠폰', icon: Ticket, desc: '단계별 할인 · 쿠폰 발급/발송', href: '/seller/groupbuy-coupon' },
      { key: 'short-clips',     label: '숏클립 관리',      icon: Film,   desc: '상품 숏폼 등록 · HOME 노출', href: '/seller/short-clips' },
      // STEP SOCIAL-COMMENT-UI-1 · Instagram / TikTok 게시물 댓글 통합 관리
      { key: 'comments',        label: '댓글관리',         icon: MessageCircle, desc: 'Instagram · TikTok 게시물 댓글', href: '/seller/comments' },
    ],
  },
  {
    title: '정산 · 광고',
    items: [
      { key: 'analytics',    label: '통계',       icon: BarChart3, desc: '판매 · 매출 통계' },
      { key: 'ads',          label: '광고 관리',  icon: Megaphone, desc: '홈 노출 · 검색 광고' },
      { key: 'wallet',       label: '충전금',     icon: Wallet,    desc: '잔액 · 충전' },
      { key: 'transactions', label: '사용 내역',  icon: Receipt,   desc: '거래 · 사용 이력' },
    ],
  },
  {
    title: '고급 관리 · 원본 화면',
    items: [
      { key: 'broadcasts',  label: '방송 관리 (고급)',     icon: Radio,        desc: '방송 상세 편집 · 홈 편성표' },
      { key: 'products',    label: '상품 관리 (고급)',     icon: Package,      desc: 'SKU · 매입처 · 필터' },
      { key: 'oms',         label: '주문 작업대 (고급)',   icon: ClipboardList, desc: 'OMS · 저장된 보기' },
      { key: 'fulfillment', label: '출고 관리',            icon: ScanLine,     desc: '피킹 · 검수 · 송장' },
      { key: 'inbound',     label: '입고 관리',            icon: PackagePlus,  desc: '입고 예정 · 부분입고' },
      { key: 'purchase',    label: '발주 관리',            icon: ShoppingCart, desc: '발주서 · 승인' },
      { key: 'rma',         label: '취소·교환·반품',       icon: RotateCcw,    desc: 'RMA 목록 · 처리' },
      { key: 'customers',   label: '고객관리 (고급)',      icon: Users2,       desc: 'Customer 360 · CS 이력' },
    ],
  },
  {
    title: '판매자 설정',
    items: [
      { key: 'profile',     label: '판매자 프로필', icon: UserIcon,  desc: '이름 · 소개 · 이미지' },
      { key: 'settings',    label: '설정',          icon: Settings,  desc: '알림 · 배송 · 정책' },
      { key: 'followers',   label: '팔로워',        icon: Users2,    desc: '팔로우 사용자 목록' },
    ],
  },
];

export default function MoreHub({ onGoRaw }) {
  return (
    <div className="space-y-6" data-testid="more-hub-section">
      <div>
        <p className="text-xs font-bold uppercase tracking-widest text-gray-400">더보기</p>
        <h2 className="mt-1 text-2xl md:text-3xl font-black tracking-tight" style={{ fontFamily: 'Manrope, sans-serif' }}>
          부가 기능
        </h2>
        <p className="mt-1 text-xs text-gray-500">자주 사용하지 않는 관리 화면과 원본(고급) 화면들.</p>
      </div>

      {GROUPS.map((g) => (
        <div key={g.title} data-testid={`more-group-${g.title}`}>
          <p className="text-xs font-black tracking-widest uppercase text-gray-500 mb-2">{g.title}</p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
            {g.items.map((it) => {
              // href 가 있으면 별도 페이지로 이동 · 없으면 대시보드 내 section 전환
              const inner = (
                <>
                  <div className="w-9 h-9 rounded-lg bg-[#FF3B30]/10 flex items-center justify-center flex-shrink-0">
                    <it.icon size={16} className="text-[#FF3B30]" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-sm font-black">{it.label}</p>
                    <p className="text-[11px] text-gray-500 truncate">{it.desc}</p>
                  </div>
                </>
              );
              const cls = "flex items-center gap-3 p-3 rounded-lg border border-black/10 dark:border-white/10 bg-white dark:bg-[#141414] hover:border-[#FF3B30]/40 hover:-translate-y-0.5 transition text-left";
              if (it.href) {
                return (
                  <Link key={it.key} to={it.href} className={cls} data-testid={`more-item-${it.key}`}>
                    {inner}
                  </Link>
                );
              }
              return (
                <button key={it.key} onClick={() => onGoRaw(it.key)}
                  className={cls} data-testid={`more-item-${it.key}`}>
                  {inner}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
